const COMPANY_AGNOSTIC_OAUTH_PATH_PREFIXES = [
    '/api/v1/oauth/',
    '/api/core/oauth/',
    '/oauth/',
];

export function isCompanyAgnosticOAuthReturnUrl(return_url: string) {
    const normalized_return_url = return_url.trim();
    if (!normalized_return_url || normalized_return_url.startsWith('//') || normalized_return_url.startsWith('/\\')) {
        return false;
    }

    try {
        const pathname = new URL(normalized_return_url, 'https://return-url.local').pathname;
        return COMPANY_AGNOSTIC_OAUTH_PATH_PREFIXES.some(prefix =>
            pathname.toLowerCase().startsWith(prefix)
        );
    }
    catch {
        return false;
    }
}
